import { router } from '@inertiajs/react'
import AuthLayout from '@/layouts/AuthLayout'
import { AuthCard } from '@/components/AuthCard'
import { Button } from '@/components/ui/button'
import { formatDate } from '@/lib/date'
import { UsersIcon } from 'lucide-react'

interface Invitation {
  token: string
  email: string
  role: 'admin' | 'member'
  expires_at: string
  project_name?: string
  inviter_email?: string
}

interface Props {
  invitation_summary: Invitation
}

export default function ProjectInvitationsAccept ({ invitation_summary: invitation }: Props): React.ReactElement {
  function handleAccept (e: React.SubmitEvent): void {
    e.preventDefault()
    router.post(`/invitations/${invitation.token}/accept`)
  }

  return (
    <AuthLayout>
      <AuthCard maxWidth='max-w-[420px]'>
        <div className='w-14 h-14 rounded-full bg-(--bp-accent-pale) flex items-center justify-center mx-auto mb-5 text-(--bp-accent)'>
          <UsersIcon width={28} height={28} />
        </div>

        <div className='text-[20px] font-bold text-(--bp-ink) text-center mb-5'>
          プロジェクトへの招待
        </div>

        <div className='bg-(--bp-surface2) border border-(--bp-border) rounded-[10px] p-[18px] mb-[22px]'>
          {(invitation.project_name != null && invitation.project_name !== '') && (
            <div className='flex justify-between items-center py-1.5 border-b border-(--bp-border)'>
              <span className='text-xs text-(--bp-ink3)'>プロジェクト</span>
              <span className='text-[13px] font-semibold text-(--bp-ink)'>{invitation.project_name}</span>
            </div>
          )}
          {(invitation.inviter_email != null && invitation.inviter_email !== '') && (
            <div className='flex justify-between items-center py-1.5 border-b border-(--bp-border)'>
              <span className='text-xs text-(--bp-ink3)'>招待者</span>
              <span className='text-xs font-medium text-(--bp-ink2)'>{invitation.inviter_email}</span>
            </div>
          )}
          <div className='flex justify-between items-center py-1.5 border-b border-(--bp-border)'>
            <span className='text-xs text-(--bp-ink3)'>権限</span>
            <span
              className={
                invitation.role === 'admin'
                  ? 'inline-block px-2 py-[2px] rounded text-[11px] font-semibold bg-(--bp-accent-pale) text-(--bp-accent)'
                  : 'inline-block px-2 py-[2px] rounded text-[11px] font-semibold bg-(--bp-surface2) text-(--bp-ink3)'
              }
            >
              {invitation.role === 'admin' ? '管理者' : 'メンバー'}
            </span>
          </div>
          <div className='flex justify-between items-center py-1.5'>
            <span className='text-xs text-(--bp-ink3)'>有効期限</span>
            <span className='text-xs font-medium text-(--bp-ink2)'>
              {formatDate(invitation.expires_at)} まで
            </span>
          </div>
        </div>

        <form onSubmit={handleAccept}>
          <Button size='lg' type='submit'>
            このプロジェクトに参加する
          </Button>
        </form>

        <div className='text-[11px] text-(--bp-ink3) mt-4 leading-[1.6] text-center'>
          このリンクは招待者からのメールに含まれています。
          <br />
          身に覚えのない招待は無視してください。
        </div>
      </AuthCard>
    </AuthLayout>
  )
}
